import React from 'react';
import Text from 'components/Text/Text';
import { Checkbox } from 'antd';
import style from './IsOpenPriceCheckbox.module.scss';

interface IProps {
	toggleIsOpenPriceServiceCharge: () => void;
	isOpenPriceServiceCharge: boolean;
}

export const IsOpenPriceCheckbox: React.FC<IProps> = React.memo(
	({ toggleIsOpenPriceServiceCharge, isOpenPriceServiceCharge }) => {
		return (
			<Checkbox
				data-test="IsOpenPriceCheckbox"
				name="isOpenPriceServiceCharge"
				className={style.checkbox}
				onChange={toggleIsOpenPriceServiceCharge}
				checked={isOpenPriceServiceCharge}>
				<Text translationNameSpace="form" translationKey="openPriceLabel" asFragment={true} />
			</Checkbox>
		);
	},
);
